module.exports = __webpack_public_path__ + "static/plane-cde022472a331d418a08da1b8595b616.svg";